// Paleta del tema Vibrante. Máxima saturación para operadores que
// priorizan distinción visual sobre suavidad.

export default {
  meta: {
    id: 'vibrante',
    nombre: 'Vibrante',
    descripcion: 'Colores más saturados, preferido por operadores que quieren maximizar distinción visual',
    modo: 'claro',
  },

  paleta: {
    'patrulla-normal':         '#0C447C',
    'patrulla-atenuado':       '#378ADD',

    'camara-normal':           '#1D9E75',
    'camara-atenuado':         '#5DCAA5',

    'lpr-normal':              '#3C3489',
    'lpr-atenuado':            '#7F77DD',

    'bus-normal':              '#3B6D11',
    'bus-atenuado':            '#97C459',

    'sensor-standby':          '#BA7517',
    'sensor-alerta':           '#A32D2D',

    'incidente-activo':        '#A32D2D',
    'incidente-baja':          '#E24B4A',

    // Familia cromática del manual oficial federal — versión vibrante
    // (tonos profundos/saturados, contraste alto sobre fondo oscuro).
    'cat-seguridad':           '#2B5FA8',   // azul profundo
    'cat-medico':              '#2E8540',   // verde profundo
    'cat-proteccion-civil':    '#C49A1F',   // amarillo dorado profundo (separado de asistencia)
    'cat-servicios-publicos':  '#5E3FA6',   // morado profundo
    'cat-asistencia':          '#A85725',   // naranja-rojizo profundo (separado de PC)
    'cat-otros-servicios':     '#4A5562',   // gris oscuro
    'cat-mal-uso':             '#A32D2D',   // rojo profundo

    'device-policia-municipal-normal':    '#0C447C',
    'device-policia-municipal-atenuado':  '#5C8FBE',
    'device-policia-estatal-normal':      '#082E58',
    'device-policia-estatal-atenuado':    '#4A7AA0',
    'device-policia-ministerial-normal':  '#5A2D85',
    'device-policia-ministerial-atenuado':'#9A78BD',
    'device-gn-normal':                   '#7E5519',
    'device-gn-atenuado':                 '#BA9962',
    'device-transito-normal':             '#A05012',
    'device-transito-atenuado':           '#D4946D',
    'device-ambulancia-normal':           '#9B2D58',
    'device-ambulancia-atenuado':         '#CE7B98',
    'device-bomberos-normal':             '#8B2517',
    'device-bomberos-atenuado':           '#C56F5F',
    'device-proteccion-civil-normal':     '#C48020',
    'device-proteccion-civil-atenuado':   '#E0B273',
    'device-transporte-publico-normal':   '#3B6D11',
    'device-transporte-publico-atenuado': '#7AA859',
    'device-funcionario-normal':          '#27595A',
    'device-funcionario-atenuado':        '#7AA0A1',
    'device-dron-normal':                 '#5C2D9A',
    'device-dron-atenuado':               '#A07ED1',
    'device-otros-normal':                '#4A5562',
    'device-otros-atenuado':              '#929BA5',

    'sos-esperando':           '#993556',
    'sos-en-progreso':         '#993556',
    'sos-finalizado':          '#D4537E',

    'neutro-apagado':          '#5F5E5A',
    'neutro-texto-oscuro':     '#2C2C2A',
    'neutro-texto-claro':      '#FFFFFF',
  },

  overrides: {},
}
